import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';

var DetailModal = function (_super) {
  __extends(DetailModal, _super);

  function DetailModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.listData = [];
    _this.columns = [{
      title: _this.t('序号'),
      scopedSlots: {
        customRender: 'index'
      }
    }, {
      title: _this.t('运单号'),
      dataIndex: 'way_bill_number',
      filterEmpty: true
    }, {
      title: _this.t('客户单号'),
      dataIndex: 'order_id',
      filterEmpty: true
    }, {
      title: _this.t('跟踪号'),
      dataIndex: 'tracking_number',
      filterEmpty: true
    }, {
      title: _this.t('小标签号'),
      dataIndex: 'small_number',
      filterEmpty: true
    }];
    return _this;
  }

  DetailModal.prototype.onCodeChange = function () {
    if (this.visible) {
      this.queryList({
        shipping_mark_number: this.code
      });
    } else {
      this.listData = [];
    }
  };

  DetailModal.prototype.queryList = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.transportOrder.searchShippingMarkList(param)];

          case 1:
            data = _a.sent().data;
            this.listData = data.package_shipping_marks;
            console.log(data.package_shipping_marks, 898989898989);
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: String,
    "default": ''
  })], DetailModal.prototype, "code", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], DetailModal.prototype, "onCodeChange", null);

  __decorate([loading('loadingStatus')], DetailModal.prototype, "queryList", null);

  DetailModal = __decorate([Component], DetailModal);
  return DetailModal;
}(Vue);

export default DetailModal;